import React, { useEffect } from 'react';
import { DealPipelineView } from '@/components/views/DealPipelineView';

export const NewBusinessPage = () => {

	return <DealPipelineView pipelineId={process.env.REACT_APP_PIPELINE_NEW_BUSINESS}/>;
};